import React, { useEffect, useState } from "react";
import axios from "axios";
import { Grid, Box, Typography } from "@mui/material";

function Instagram({ userId, accessToken }) {
  const [instaItems, setInstaItems] = useState([]);

  useEffect(() => {
    const fetchMedia = async (id) => {
      const mediaUrl = `https://graph.instagram.com/${id}?access_token=${accessToken}&fields=permalink`;

      try {
        const res = await axios.get(mediaUrl);
        const permalink = res.data.permalink;

        if (!permalink || !/^https:\/\/www\.instagram\.com\/(p|reel)\//.test(permalink)) {
          console.warn("Invalid permalink format:", permalink);
          return null;
        }

        return { permalink };
      } catch (error) {
        console.error("Error fetching media:", error);
        return null;
      }
    };

    const doFetch = async () => {
      if (!userId || !accessToken) {
        console.log("Missing userId or accessToken");
        return;
      }

      const instaUrl = `https://graph.instagram.com/${userId}/media?access_token=${accessToken}`;

      try {
        const res = await axios.get(instaUrl);
        const mediaList = res.data.data;
        console.log("Media list response:", mediaList);

        const fetchedItems = [];

        for (let i = 0; i < mediaList.length && i < 9; i++) {
          const item = mediaList[i];
          const media = await fetchMedia(item.id);
          if (media) fetchedItems.push(media);
        }

        setInstaItems(fetchedItems);
      } catch (error) {
        console.error("Error fetching Instagram media list:", error);
      }
    };

    doFetch();
  }, [userId, accessToken]);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" align="center" gutterBottom>
      <p style={{fontSize:"50px", color:"white"}}>Our Instagram Feed 🎸</p>
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        {instaItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              sx={{
                width: "100%",
                maxWidth: 500,
                margin: "auto",
                overflow: "hidden",
              }}
            >
              <iframe
                src={`${item.permalink}embed`}
                width="100%"
                height="600"
                frameBorder="0"
                allowFullScreen
                title={`Instagram post ${index}`}
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Instagram;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Grid} from "@mui/material";
// function Instagram({ userId, accessToken, instaUrl }) {
//   const [instaItems, setInstaItems] = useState([]);

//   useEffect(() => {
//     console.log("instaUrl received in props:", instaUrl);
//     const fetchMedia = async (id) => {
//         const mediaUrl = `https://graph.instagram.com/${id}?access_token=${accessToken}&fields=media_type,media_url,permalink`;

//       try {
//         const res = await axios.get(mediaUrl);
//         return {
//             permalink: res.data.permalink,
//             mediaUrl: res.data.media_url,
//             mediaType: res.data.media_type,
//         };
//       } catch (error) {
//         console.error("Error fetching media:", error);
//         return null;
//       }
//     };

//     const doFetch = async () => {
//       if (!userId || !accessToken) {
//         console.log("userId or accessToken is undefined:", { userId, accessToken });
//         return;
//       }

//       try {
//         const res = await axios.get(instaUrl);
//         const json = res.data.data;
//         console.log(json);

//         const fetchedItems = [];

//         for (let i = 0; i < json.length && i < 9; i++) {
//           const item = json[i];
//           const itemId = item.id;

//           const instaItem = await fetchMedia(itemId);
//           if (instaItem) {
//             fetchedItems.push(instaItem);
//           }
//         }

//         setInstaItems(fetchedItems);
//       } catch (error) {
//         console.error("Error fetching Instagram feed:", error);
//       }
//     };

//     doFetch();
//   }, [userId, accessToken, instaUrl]);

//   return (
// <Grid container spacing={2}>
//   {instaItems.map((item, index) => (
//     <Grid item xs={12} sm={6} md={4} key={index}>
//       <a href={item.permalink} target="_blank" rel="noopener noreferrer" style={{ display: "block", width: "100%" }}>
//         {item.mediaType === "VIDEO" ? (
//           <video
//             src={item.mediaUrl}
//             controls
//             style={{ width: "100%", height: "auto", borderRadius: 8 }}
//           />
//         ) : (
//           <img
//             src={item.mediaUrl}
//             alt="Instagram media"
//             style={{ width: "100%", height: "auto", borderRadius: 8 }}
//           />
//         )}
//       </a>
//     </Grid>
//   ))}
// </Grid>
//   )
// }

// export default Instagram;